var _linearGradient, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStripeButtonDisabled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 130",
    width: 130,
    height: 130,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs204"
  }, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    href: "#linearGradient4907",
    id: "linearGradient4909",
    x1: 24.202744,
    y1: 51.679764,
    x2: 152.20274,
    y2: 179.67976,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-23.202745,-50.679753)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient4907"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#9895a0",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop4903"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#a1a2ab",
      stopOpacity: 1
    },
    offset: 1,
    id: "stop4905"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style183"
  }, "\n    .st0{fill-rule:evenodd;clip-rule:evenodd;fill:#6772E5;}\n  ")), /*#__PURE__*/React.createElement("g", {
    id: "layer3",
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "url(#linearGradient4909)",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 0.72299999,
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 0
    },
    id: "rect218",
    width: 128,
    height: 128,
    x: 1,
    y: 1,
    ry: 14.273413
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipRule: "evenodd",
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillRule: "evenodd"
    },
    id: "path197",
    d: "m 58.550005,46.599973 c 0,-3.9 3.2,-5.4 8.5,-5.4 7.6,0 17.19999,2.30001 24.79999,6.4 v -23.49998 c -8.3,-3.3 -16.49999,-4.6 -24.79999,-4.6 -20.3,0 -33.8,10.6 -33.8,28.3 0,27.60001 38,23.20001 38,35.10001 0,4.6 -4,6.1 -9.6,6.1 -8.3,0 -18.9,-3.40002 -27.3,-8 v 23.800007 c 9.3,4 18.7,5.7 27.3,5.7 20.79999,0 35.09999,-10.30002 35.09999,-28.200007 -0.1,-29.80001 -38.19999,-24.50001 -38.19999,-35.70003 z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeButtonDisabled);
export default __webpack_public_path__ + "static/media/StripeButtonDisabled.9444aedd47a615a04d33680b80c1a493.svg";
export { ForwardRef as ReactComponent };